import { usePrefetchQuery, useQuery } from "@tanstack/react-query";
import { t } from "ttag";

import { ScreenLayout } from "@/app/components/layouts";
import { billingQueriesStore } from "@/features/billing/api";
import { productsQueriesStore } from "@/features/products/api";
import { useMarkShopVisited } from "@/features/products/hooks";
import {
  CategoriesFilter,
  ShopOverviewHeader,
  ShopProductsList,
} from "@/features/products/sections";
import { referralQueriesStore } from "@/features/referral/api";
import { LogoLoader } from "@/shared/components";
import { usePageTitle } from "@/shared/hooks";
import { EmptyState } from "@/shared/ui";

export const ShopOverviewScreen = () => {
  usePageTitle(t`Shop`);

  usePrefetchQuery(billingQueriesStore.payments._ctx.method);
  usePrefetchQuery(referralQueriesStore.credit);

  useMarkShopVisited();

  const {
    data: categories,
    isLoading,
    isSuccess,
    isError,
  } = useQuery(productsQueriesStore.products.shop);

  if (isError) {
    return (
      <EmptyState.Root>
        <EmptyState.Icon />
        <EmptyState.Title>{t`Hmm, something's not right`}</EmptyState.Title>
        <EmptyState.Description>{t`We're having trouble loading products right now. Try refreshing the page or check back soon!`}</EmptyState.Description>
      </EmptyState.Root>
    );
  }

  return (
    <ScreenLayout className="gap-0 pt-0 md:pt-0">
      <LogoLoader show={isLoading} withOverlay />

      {isSuccess &&
        (categories.length ? (
          <>
            <div className="sticky-header sticky top-0 z-30 flex flex-col gap-6 bg-white pt-6 pb-4 contain-inline-size md:pt-12">
              <ShopOverviewHeader />

              {categories.length > 1 && (
                <CategoriesFilter categories={categories} />
              )}
            </div>

            <ShopProductsList categories={categories} />
          </>
        ) : (
          <EmptyState.Root>
            <EmptyState.Icon />
            <EmptyState.Description>
              {t`Looks like there are no products available.`}
            </EmptyState.Description>
          </EmptyState.Root>
        ))}
    </ScreenLayout>
  );
};
